<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="bg_gray teacher_content">
			<div class="flex famous_position w1200">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/study" class="cl_gray">趣学习</router-link>  >  {{data.teacher_data.name}}</p>
				</div>
				<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
			</div>
			<div class="w1200 radius8 bs bg_white">
				<div class="teacher_cont">
					<div class="teacher_l tc" v-if="JSON.stringify(data.teacher_data) != '{}'">
						<img :src="data.teacher_data.avatar" class="radius" />
						<p class="f18px cl_dark mat20">{{data.teacher_data.name}}</p>
						<div class="cl_gray f16px mat30" v-html="data.teacher_data.intro"></div>
					</div>
					<div class="teacher_r">
						<div class="practice_title f20px cl_dark" v-if="data.hot_pack.length > 0">热门</div>
						<div class="teacher_hot" v-if="data.hot_pack.length > 0">
							<router-link :to="{ path: '/video', query: { id: item.id}}" v-for="(item,index) in data.hot_pack" :key="index" class="teacher_hot_list">
								<img :src="item.pic" class="block radius8" />
								<p class="f18px cl_dark mat10 clip">{{item.name}}</p>
								<p class="cl_gray mat5">观看{{item.browse_num}}</p>
							</router-link>
						</div>
						<div class="practice_title f20px cl_dark" v-if="data.pack.data.length > 0">最新</div>
						<div class="teacher_hot" v-if="data.pack.data.length > 0">
							<router-link :to="{ path: '/video', query: { id: item.id}}" v-for="(item,index) in data.pack.data" :key="index" class="teacher_hot_list">
								<img :src="item.pic" class="block radius8" />
								<p class="f18px cl_dark mat10 clip">{{item.name}}</p>
								<p class="cl_gray mat5">观看{{item.browse_num}}</p>
							</router-link>
						</div>
						<div class="famous_page flex" v-if="data.pack.data.length > 0">
							<div class="famous_page_l f16px cl_gray"> </div>
							<div class="famous_page_r cl_dark">
								<el-pagination background layout="prev, pager, next"
								@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'teacher',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				studyNav: -1,
				subjectIndex: false, //学科分类显示
				myInfo: {},
				public: {},
				id: "",
				data: {
					teacher_data: {},
					hot_pack: [],
					pack: {
						data: {},
					},
				},
				limit_hot: 3,
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
			}
		},
		mounted() {
			
		},
		created() {
			this.id = this.$route.query.id;
			this.getVideo();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//视频
			getVideo () {
				this.$get("/api/course/get_teacher_course_list",{
					teacher_id: this.id,
					limit_hot: this.limit_hot,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.data = res.data;
					this.total = res.data.pack.total;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getVideo();
			},
		},
	}
</script>

<style>
</style>
